// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2prMs","title":"Info_title__1YGm_","links":"Info_links__1c-Tf","link":"Info_link__1qLWP","logo":"Info_logo__28SUt"};